import React from 'react';

const Logo = ({ className = "h-8 w-8" }) => {
  return (
    <img 
      src="https://static.prod-images.emergentagent.com/jobs/7a5900d2-3763-4b31-bd0d-3d393c3842bc/images/2167b9410852fde67ff3282340a1e57deb013326dedeb7ce7164a5950f74acc5.png"
      alt="cyQRus Logo"
      className={className}
    />
  );
};

export default Logo;
